// removed by extract-text-webpack-plugin
module.exports = {"header":"_2QZdp","nyh_share--article":"_1GF2Y","nyh_share--story":"_23pWZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ShareButtons.scss
 ** module id = 110
 ** module chunks = 0
 **/